module.exports = __webpack_public_path__ + "static/media/offer_center_line.5813b0b1.svg";